import { OrderListView } from '@components/pages/OrderListView/OrderListView';
import { ORDER_STATUS_MAP } from '@trukt/portal-utils/OrderStatusMap';
import type { OrderListRouteSearch } from '@components/pages/OrderListView/context';

export const validateOrderListSearch = (search: Record<string, unknown>): OrderListRouteSearch => ({
  ...search,
  filters: typeof search.filters === 'string' ? search.filters : undefined,
  sort: typeof search.sort === 'string' ? search.sort : undefined,
  globalSearch: typeof search.globalSearch === 'string' ? search.globalSearch : undefined,
});

export interface OrderListRouteProps {
  status?: ORDER_STATUS_MAP;
  reportGuid?: string;
}

export function OrderListRoute({ status = ORDER_STATUS_MAP.ALL, reportGuid }: OrderListRouteProps) {
  return <OrderListView status={status} reportGuid={reportGuid} />;
}
